"use client";

import { useEffect, useState } from "react";
import { useQuery } from "convex/react";
import type { FunctionReturnType } from "convex/server";
import { api } from "@convex/_generated/api";
import {
  SIGN_IN_CODE_DELIVERY,
  SIGN_IN_CODE_UNDELIVERED_MESSAGE,
} from "@convex/constants/signInCodeRefusals.lib";
import { trackAuthFailure, type AuthAttempt } from "@/lib/auth/sign-in/auth-tracking";

export type SentSignInCode = FunctionReturnType<typeof api.auth.magicCode.sendSignInCode>;

export function useSignInCodeDelivery(attempt: AuthAttempt) {
  const [sent, setSent] = useState<SentSignInCode | null>(null);
  const deliveryId = sent?.deliveryId;
  const status = useQuery(
    api.auth.codeDispatch.signInCodeDelivery,
    sent && deliveryId ? { email: sent.email, deliveryId } : "skip",
  );
  const undeliverable = status === SIGN_IN_CODE_DELIVERY.UNDELIVERABLE;
  const { entryPoint, method } = attempt;
  useEffect(() => {
    if (undeliverable) trackAuthFailure({ entryPoint, method }, "send", "undeliverable");
  }, [undeliverable, deliveryId, entryPoint, method]);
  return {
    error: undeliverable ? SIGN_IN_CODE_UNDELIVERED_MESSAGE : null,
    setSent,
  };
}
